import { Autocomplete, AutocompleteChanges } from '@equinor/eds-core-react';
import * as Styled from './SettingSelect.styled';
import { useIsOwnerOrAdmin } from '../../../../../hooks/useIsOwnerOrAdmin';
import {
  ComputeMethod,
  InputValueType,
  ListComputeSettingsModelDto,
} from '../../../../../api/generated';
import { Variants } from '@equinor/eds-core-react/dist/types/components/types';

export const CaseSettingSelect = ({
  label,
  settingType,
  caseMethod,
  options,
  selectedValue,
  setValue,
  variant,
  singleSelect,
  readOnly,
  customOptionDisabled,
}: {
  label: string;
  settingType?: InputValueType;
  caseMethod?: ComputeMethod;
  options?: ListComputeSettingsModelDto[];
  selectedValue?: ListComputeSettingsModelDto[];
  setValue?: React.Dispatch<
    React.SetStateAction<ListComputeSettingsModelDto[] | undefined>
  >;
  variant?: Variants | undefined;
  singleSelect?: boolean;
  readOnly?: boolean;
  customOptionDisabled?: (option: ListComputeSettingsModelDto) => boolean;
}) => {
  const isOwnerOrAdmin = useIsOwnerOrAdmin();
  const onSelectChange = (
    changes: AutocompleteChanges<ListComputeSettingsModelDto>,
  ) => {
    setValue && setValue(changes.selectedItems);
  };

  const disabled =
    (caseMethod === ComputeMethod.NET_TO_GROSS &&
      settingType === InputValueType.ATTRIBUTE_NAME) ||
    (caseMethod === ComputeMethod.INDICATOR &&
      (settingType === InputValueType.ATTRIBUTE_NAME ||
        settingType === InputValueType.NET_TO_GROSS ||
        label === 'Architectural elements filter')) ||
    !isOwnerOrAdmin;

  return (
    <Styled.MetadataWrapper>
      <Autocomplete
        label={label}
        disabled={disabled}
        readOnly={readOnly}
        options={options && options.length > 0 ? options : []}
        optionLabel={(option) => {
          const raw =
            option.equinorName !== null && option.equinorName !== undefined
              ? option.equinorName
              : option.name ?? '';
          return raw.charAt(0).toUpperCase() + raw.slice(1);
        }}
        selectedOptions={selectedValue ?? []}
        onOptionsChange={onSelectChange}
        multiple={!singleSelect && settingType !== InputValueType.NET_TO_GROSS}
        optionDisabled={customOptionDisabled}
        variant={variant}
      ></Autocomplete>
    </Styled.MetadataWrapper>
  );
};
